import { renderMenuItem } from "../utils/renderItems";
import {
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "../../../ui/dropdown-menu";
import { SubMenuItemType } from "../types";

export const SubMenuGroup = ({
  subMenuItem,
}: {
  subMenuItem: SubMenuItemType;
}) => {
  return (
    <>
      <DropdownMenuSub>
        <DropdownMenuSubTrigger
          disabled={subMenuItem.disabled}
          className="m-0 rounded-none py-1.5 pl-3 pr-1"
        >
          {subMenuItem.icon}
          {subMenuItem.label}
        </DropdownMenuSubTrigger>
        <DropdownMenuPortal>
          <DropdownMenuSubContent>
            {subMenuItem.subItems.map((subItem, index) =>
              renderMenuItem(subItem, index),
            )}
          </DropdownMenuSubContent>
        </DropdownMenuPortal>
      </DropdownMenuSub>
      {subMenuItem.separator && <DropdownMenuSeparator />}
    </>
  );
};
